
//Enrollment statuses
export const enrollmentStatuses = {
  ACTIVE: 'active',
  UP_NEXT: 'up_next',
  SCHEDULED: 'scheduled',
  PAUSED: 'paused',
  CANCELED: 'canceled',
  OPTED_OUT: 'opted_out',
  COMPLETED: 'completed',
  DISABLED: 'disabled',
  NOT_ENGAGED: 'not_engaged',
  WHATSAPP_WINDOW_VIOLATED: 'whatsapp_window_violated',
  ERROR: 'error',
}

//Enrollment status options
export const enrollmentStatusOptions = [
  {
    value: enrollmentStatuses.ACTIVE,
    label: 'Active',
  },
  {
    value: enrollmentStatuses.UP_NEXT,
    label: 'Up next',
  },
  {
    value: enrollmentStatuses.SCHEDULED,
    label: 'Scheduled',
  },
  {
    value: enrollmentStatuses.PAUSED,
    label: 'Paused',
  },
  {
    value: enrollmentStatuses.CANCELED,
    label: 'Canceled',
  },
  {
    value: enrollmentStatuses.OPTED_OUT,
    label: 'Opted out',
  },
  {
    value: enrollmentStatuses.COMPLETED,
    label: 'Completed',
  },
  {
    value: enrollmentStatuses.DISABLED,
    label: 'Disabled',
  },
  {
    value: enrollmentStatuses.NOT_ENGAGED,
    label: 'Not engaged',
  },
  {
    value: enrollmentStatuses.WHATSAPP_WINDOW_VIOLATED,
    label: 'WhatsApp reply window expired',
  },
  {
    value: enrollmentStatuses.ERROR,
    label: 'Error',
  },
]

//Enrollment sort options
export const enrollmentSortOptions = [
  {label: 'Last message', value: '-lastMessageSentAt'},
  {label: 'Newest first', value: '-createdAt'},
  {label: 'Oldest first', value: 'createdAt'},
]

//Enrollment filter options
export const enrollmentFilterOptions = [
  {label: 'Recent', value: 'default'},
  {label: 'Active', value: 'active'},
  {label: 'Paused', value: 'paused'},
  {label: 'Archived', value: 'archived'},
]
